<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 总收益 -->
    <div>
      <div class="color052154 mgb-20">总收益：####</div>
      <!-- 表格 -->
      <el-table stripe :data="tableData" border style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="100"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="date" label="时间" width="250">
        </el-table-column>
        <el-table-column prop="num" label="设备编号" width="250">
        </el-table-column
        ><el-table-column prop="orderNum" label="分润订单号" width="250">
        </el-table-column
        ><el-table-column prop="money" label="订单实付金额" width="250">
        </el-table-column>
        <el-table-column prop="earnings" label="分润收益"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02 12:12:12",
          num: "999999",
          orderNum: "999999",
          money: "999.99",
          earnings: "999.99",
        },
      ], //收益详情数据
    };
  },
  methods: {
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
</style>
